import React from 'react';

import Icon from '@plone/volto/components/theme/Icon/Icon';

import DraftJsDropdownButton from './DraftJsDropdownButton';

import formatSVG from '@plone/volto/icons/format.svg';

import createToggleInlineStyleButton from './createToggleInlineStyleButton';

//font-size
export const FONT_STYLE_MAP = {
  FONT_SIZE_05: { fontSize: '0.5em' },
  FONT_SIZE_06: { fontSize: '0.6em' },
  FONT_SIZE_08: { fontSize: '0.8em' },
  FONT_SIZE_12: { fontSize: '1.2em' },
  FONT_SIZE_14: { fontSize: '1.4em' },
  FONT_SIZE_16: { fontSize: '1.6em' },
  FONT_SIZE_18: { fontSize: '1.8em' },
  FONT_SIZE_20: { fontSize: '2em' },
  FONT_SIZE_25: { fontSize: '2.5em' },
  FONT_SIZE_30: { fontSize: '3em' },
};

const TextSizeButton = (props) => {
  //const createInlineStyleButton = props.draftJsCreateInlineStyleButton.default;

  const options = Object.keys(FONT_STYLE_MAP).map((s) => {
    return {
      block_type: s,
      value: createToggleInlineStyleButton({
        prefix: 'FONT_SIZE_',
        styleName: s,
        style: FONT_STYLE_MAP[s],
        //<Icon name={formatSVG} size={FONT_STYLE_MAP[s].fontSize} />,
        children: (
          <span class="text" style={FONT_STYLE_MAP[s]}>
            {FONT_STYLE_MAP[s].fontSize.replace('em', '')}
          </span>
        ),
        title: FONT_STYLE_MAP[s].fontSize,
      }),
    };
  });

  return (_props) => (
    <DraftJsDropdownButton
      {..._props}
      title="Dimensione del font"
      optionsList={options}
      content={<Icon name={formatSVG} size="1em" />}
    />
  );
};

const TextSizeRenderer = {};
Object.keys(FONT_STYLE_MAP).forEach((k) => {
  TextSizeRenderer[k] = (children, { keys }) => {
    return children.map((child, i) => (
      <span id={keys?.[i]} key={keys?.[i]} style={FONT_STYLE_MAP[k]}>
        {child}
      </span>
    ));
  };
});

export { TextSizeButton, TextSizeRenderer };
